import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './TableStates.css';
import { useSlowQueryNotice } from './useSlowQueryNotice';
/**
 * CZNA-538 — first-load state for a table: placeholder rows plus a worded status.
 *
 * Replaces a centred `<Loading size="xlarge" />`. Two things that spinner could not do:
 * it did not hold the table's height (so the arriving rows made the pane jump), and it
 * did not say anything, which over a slow corpus query is indistinguishable from the
 * empty result rendered a few lines below it in every one of these routes.
 *
 * The status line is text, not only an animation — `role="status"` so it also reaches a
 * screen reader, and `aria-busy` on the placeholder rows so they are not read as data.
 */
var TableLoadingSkeleton = function (_a) {
    var _b = _a.rows, rows = _b === void 0 ? 8 : _b, _c = _a.columns, columns = _c === void 0 ? [3, 8, 3, 3] : _c, _d = _a.testId, testId = _d === void 0 ? 'table-loading-skeleton' : _d;
    var isSlow = useSlowQueryNotice(true);
    return (React.createElement("div", { className: css.skeleton, "data-testid": testId },
        React.createElement("div", { className: css.status, role: "status" },
            React.createElement("span", { className: css.spinnerDot, "aria-hidden": "true" }),
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.loading" })),
        React.createElement("div", { className: css.note }, isSlow && (React.createElement("span", { "data-testid": "".concat(testId, "-slow") },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.stillLoading" })))),
        React.createElement("div", { className: css.rows, "aria-hidden": "true" },
            React.createElement("div", { className: "".concat(css.row, " ").concat(css.headerRow) }, columns.map(function (weight, i) { return (React.createElement("span", { key: i, className: css.block, style: { flex: weight } })); })),
            Array.from({ length: rows }, function (_, r) { return (React.createElement("div", { key: r, className: css.row, "data-testid": "".concat(testId, "-row") }, columns.map(function (weight, i) { return (
            // Widths vary per row so the block does not read as a rendered table.
            // The fade is clamped: a caller asking for many rows must not end up
            // with invisible ones, which would silently undo the height the
            // placeholders exist to hold.
            React.createElement("span", { key: i, className: css.block, style: {
                    flex: weight,
                    opacity: Math.max(0.35, 1 - (r * 0.06)),
                    maxWidth: "".concat(70 + ((r + i) % 4) * 8, "%"),
                } })); }))); }))));
};
export default TableLoadingSkeleton;
